import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Slide,
  Stack,
  Typography,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

import xlTemplate from '../../src/assets/imports-template.xlsx';
import {
  useGetLoadReportQuery,
  useGetValidateFileQuery,
  useImportSetInitiateMutation,
  usePostLoadDataMutation,
} from '../components/core/organization/importSetSlice';
import AktivuDropzone from '../components/shared/AktivuDropzone';
import { MEDIUM_DIALOG } from '../utils/constants';

// dialog transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * UploadDialog is a full screen layout
 * @param {*} props
 * @returns
 */
const UploadDialogWithPreview = props => {
  const {
    upload_type,
    prefix,
    title,
    uploadDialog = false,
    setUploadDialog,
    uploadPrevSteps,
    useOrgId,
  } = props;

  const theme = useTheme();

  const [processBtnClick, setProcessBtnClick] = useState(0);
  const [uploadSteps, setUploadSteps] = useState([]);
  const [importSetInitiate] = useImportSetInitiateMutation();
  const [fileName, setFileName] = useState(null);
  const [validateSkip, setValidateSkip] = React.useState(true);
  const [importedFileId, setImportedFileId] = useState([]);
  const [isProcessBtnClick, setIsProcessBtnClick] = useState(false);
  const [processBtnDisable, setProcessBtnDisable] = useState(true);
  const [reportSkip, setReportSkip] = useState(true);
  const [processBtnText, setProcessBtnText] = useState('Process');
  const [postLoadData] = usePostLoadDataMutation();
  const [isDialogLoaded, setIsDialogLoaded] = useState('0');
  let loadDataSteps = [];
  const [apiCall, setApiCall] = useState(0);

  const resetComponnt = () => {
    setProcessBtnClick(0);
    setFileName(null);
    setValidateSkip(true);
    setImportedFileId([]);
    setUploadSteps([]);
  };

  const updateSteps = (data, msgObj) => {
    if (isDialogLoaded === '0') {
      let prevUploadSteps = JSON.parse(JSON.stringify(uploadSteps));
      data.push({ ...msgObj });
      loadDataSteps = JSON.parse(JSON.stringify(data));
      setUploadSteps([...prevUploadSteps, ...loadDataSteps]);
    }
  };

  const updateLoadData = loadSteps => {
    const payLoad = {
      imported_file_id: importedFileId[0],
      id: importedFileId,
    };
    postLoadData({ ...payLoad })
      .unwrap()
      .then(res => {
        if (apiCall === 1) {
          if (res.data[0]?.imported_rows < res.data[0]?.total_rows) {
            updateSteps(loadSteps, { style: {}, value: res.message });
            // setTimeout(() => {
            updateLoadData(loadDataSteps);
            // }, 0);
          } else {
            updateSteps(loadSteps, { style: {}, value: res.message });
            setReportSkip(false);
          }
        }
      })
      .catch(error => {
        if (isDialogLoaded === '0') {
          // updateSteps(loadSteps, {
          //   style: { color: 'red' },
          //   value: error.data.message
          //     ? error?.data?.message.replace(/,/g, ', ')
          //     : 'Failed to upload data',
          // });
          updateSteps(loadSteps, {
            style: { color: 'red' },
            value: 'Failed to upload data',
          });
          setReportSkip(false);
        }
      });
  };

  const {
    isSuccess: report_isSuccess,
    isError: report_isError,
    data: report_data,
    error: report_error,
  } = useGetLoadReportQuery(
    { imported_file_id: importedFileId[0] },
    {
      skip: reportSkip,
    }
  );
  if (report_isSuccess) {
    setReportSkip(true);
    let strConfig = [];
    if (report_data?.rows?.length) {
      report_data.rows.forEach((item, index) => {
        strConfig.push({
          style: {
            color: item.message === 'success' ? 'green' : 'red',
          },
          value: `${item.message} - ${item.cnt}`,
        });
      });
    } else {
      strConfig.push({
        style: {
          color: 'red',
        },
        value: 'Failed to upload data',
      });
    }
    setUploadSteps([
      ...uploadSteps,
      {
        style: {},
        value: 'Report:',
        children: [...strConfig],
      },
    ]);
    setIsProcessBtnClick(false);
    setProcessBtnDisable(true);
    setProcessBtnText('Processed');
  }
  if (report_isError) {
    let error = report_error.data?.message
      ? report_error.data.message
      : report_error.data?.error;
    if (isDialogLoaded === '0') {
      setUploadSteps([
        ...uploadSteps,
        { style: { color: 'red' }, value: error.replace(/,/g, ', ') },
      ]);
    }
    setIsProcessBtnClick(false);
    setReportSkip(true);
    setProcessBtnDisable(true);
    setProcessBtnText('Processed');
  }

  const {
    isSuccess: validate_isSuccess,
    isError: validate_isError,
    data: validate_data,
    error: validate_error,
  } = useGetValidateFileQuery(
    { id: [...importedFileId] },
    {
      skip: validateSkip,
    }
  );
  if (validate_isSuccess) {
    setValidateSkip(true);
    updateSteps(loadDataSteps, {
      style: {},
      value: validate_data.message,
    });
    // setTimeout(() => {
    updateLoadData(loadDataSteps);
    // }, 10);
  }
  if (validate_isError) {
    let error = validate_error.data?.message
      ? validate_error.data.message
      : validate_error.data?.error;
    if (isDialogLoaded === '0') {
      setUploadSteps([
        ...uploadSteps,
        { style: { color: 'red' }, value: error.replace(/,/g, ', ') },
      ]);
    }
    setIsProcessBtnClick(false);
    setValidateSkip(true);
    setProcessBtnDisable(true);
  }

  useEffect(() => {
    setUploadSteps(uploadPrevSteps);
    setProcessBtnText('Process');
  }, [uploadPrevSteps]);

  useEffect(() => {
    if (uploadDialog) {
      setProcessBtnDisable(true);
      setIsProcessBtnClick(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      loadDataSteps = [];
      setIsDialogLoaded('0');
      setUploadSteps(uploadPrevSteps);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      setApiCall(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadDialog]);

  /** 
  first api call after process btn click
  */
  const callImportSetInitiate = () => {
    let initiatePayload = {
      org_id: useOrgId,
      ast_filename: fileName,
      import_status: 'Pending',
      requested_user: useOrgId,
      total_rows: 0,
      imported_rows: 0,
    };
    let imported_file_id;

    importSetInitiate({
      ...initiatePayload,
    })
      .unwrap()
      .then(res => {
        imported_file_id = res.data[0]['imported_file_id'];
        setTimeout(() => {
          setUploadSteps([{ style: {}, value: res.message }]);
          setImportedFileId([imported_file_id]);
          setValidateSkip(false);
        }, 1000);
      })
      .catch(err => {
        if (isDialogLoaded === '0') {
          setUploadSteps([
            { style: { color: 'red' }, value: err.data.message },
          ]);
        }
        setProcessBtnDisable(true);
        setIsProcessBtnClick(false);
      });
  };

  /**
   * TODO: wire form data if required
   * Future Use. For processing FormData with the uploads
   */
  const processFormDataAndClose = () => {
    // processForm();
    // closeUploadDialog();
    setProcessBtnDisable(!processBtnDisable);
    setIsProcessBtnClick(true);
    setUploadSteps([{ style: {}, value: 'Loading Preview...' }]);
    callImportSetInitiate();
    setApiCall(1);
  };

  /**
   * 🤯 Hack Alert: to prevent type error on a dialog click when there is a grid in the dialog
   * @param {*} e
   */
  const handleDialogClick = e => {
    e.stopPropagation();
  };

  const closeUploadDialog = () => {
    setUploadDialog(false);
    resetComponnt();
    setIsDialogLoaded('1');
    importSetInitiate()?.abort();
    postLoadData()?.abort();
    setApiCall(0);
  };

  const handleProcessBtnEmit = res => {
    if (res.success) {
      setProcessBtnDisable(false);
      setFileName(res.fileName);
      setProcessBtnText('Process');
    }
  };

  const handleDropEmit = res => {
    if (res.dropFile) {
      setUploadSteps([...uploadPrevSteps]);
    }
    setProcessBtnText('Process');
  };

  const getLoadingSteps = () => {
    let ulStyle = {
      listStyle: 'auto',
      fontSize: '0.8rem',
      lineHeight: '1.5em',
      fontWeight: 500,
      marginBottom: '20px',
    };
    if (processBtnClick > 0) {
      ulStyle = { ...ulStyle, listStyle: 'none' };
    }
    return (
      <ol style={ulStyle}>
        {uploadSteps.map(item => {
          return (
            <li style={item.style} key={item.value}>
              {item.value}
              {item?.children?.length && (
                <ul
                  style={{
                    ...ulStyle,
                    listStyle: 'circle',
                    paddingLeft: '15px',
                  }}
                >
                  {item.children.map(item1 => {
                    return (
                      <li style={item1.style} key={item1.value}>
                        {item1.value}
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ol>
    );
  };

  return (
    <Dialog
      open={uploadDialog}
      TransitionComponent={Transition}
      onClose={closeUploadDialog}
      onClick={handleDialogClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...MEDIUM_DIALOG}
    >
      <DialogContent>
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          {title || 'Upload Files'}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Stack spacing={2} sx={{ minWidth: '50%' }}>
            <section style={{ marginBottom: 2 }}>
              <Typography variant="body2" sx={{ marginBottom: 1 }}>
                Download Sample Excel File
              </Typography>
              <a
                href={xlTemplate}
                rel="noopener"
                download="sample_importer"
                style={{
                  fontSize: '0.8rem',
                  borderRadius: '20px',
                  padding: '8px 20px',
                  margin: '10px auto 20px',
                  textDecoration: 'none',
                  backgroundColor: '#1a4c6e',
                  color: '#ffffff',
                }}
              >
                Download File
              </a>
              <Divider sx={{ marginTop: 2 }} />
            </section>
            <AktivuDropzone
              showTitle={false}
              upload_type={upload_type || 'generic'}
              prefix={prefix || `generic-${Date.now()}`}
              handleProcessBtnEmit={handleProcessBtnEmit}
              handleDropEmit={handleDropEmit}
              dropzonePreview={true}
            />
          </Stack>
          <Stack spacing={2} sx={{ minWidth: '50%' }}>
            <section
              style={{
                backgroundColor: '#fdfff4',
                border: '1px solid #ccc',
                padding: '10px',
                height: 'calc(100% - 16px)',
              }}
            >
              {uploadSteps && getLoadingSteps(uploadSteps)}
            </section>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#80a8c4' }}>
        <Button
          onClick={closeUploadDialog}
          variant="contained"
          style={{ backgroundColor: theme.palette.error.main }}
        >
          Close
        </Button>

        <Button
          type="button"
          variant="contained"
          disabled={processBtnDisable}
          sx={{ mt: 1, mb: 1, color: 'white' }}
          color="primary"
          onClick={processFormDataAndClose}
        >
          {processBtnText}
          {isProcessBtnClick && (
            <CircularProgress
              color="inherit"
              sx={{
                width: '17px !important',
                height: '17px !important',
                marginLeft: 2,
              }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialogWithPreview;
